import type { TimesaleId } from '~/lib/graphql/scalars'
import type { Timesale } from '../timesale'
import type { Facet } from './type'

export function createTimesaleSelected(
  isTimesale: boolean | undefined,
  timesaleId: TimesaleId | undefined,
  timesale: Timesale | undefined
): Facet[] {
  if (isTimesale) {
    return [
      {
        label: 'タイムセール開催中',
        facetKey: '',
        selected: (criteria) => criteria?.isTimesale === true,
        showInList: (criteria) => criteria?.isTimesale === true,
        add: (current) => current ?? {},
        remove(current) {
          const { isTimesale, ...rest } = current ?? {}
          return rest
        },
      },
    ]
  }

  if (timesaleId !== undefined && timesale?.timesaleId === timesaleId) {
    return [
      {
        label: timesale.name,
        facetKey: '',
        selected(criteria) {
          // isTimesale は timesaleId をオーバーライドするのでタイムセール開催中の場合は出さない
          return criteria?.isTimesale !== true && criteria?.timesaleId !== undefined
        },
        showInList(criteria) {
          // isTimesale は timesaleId をオーバーライドするのでタイムセール開催中の場合は出さない
          return criteria?.isTimesale !== true && criteria?.timesaleId !== undefined
        },
        add: (current) => current ?? {},
        remove(current) {
          const { timesaleId, ...rest } = current ?? {}
          return rest
        },
      },
    ]
  }
  return []
}
